import { apiRequest } from "../../services/apiService";
import {
    GET_ACTIVITY_LOG_REQUEST,
    GET_ACTIVITY_LOG_SUCCESS,
    GET_ACTIVITY_LOG_FAIL,
} from "../constant.js";

// Fetch Activity Logs
export const getActivityLogs = (data) => {
    return async (dispatch) => {
        dispatch({ type: GET_ACTIVITY_LOG_REQUEST });

        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/activity-logs/fetch-activity-logs`,
            data: data, 
        });

        if (response) {
            setNewToken(response.data.token); // Update token if needed
            dispatch({ type: GET_ACTIVITY_LOG_SUCCESS, payload: response.data });
        } else if (error) {
            dispatch({ type: GET_ACTIVITY_LOG_FAIL, payload: error.message });
            console.error("Error fetching activity logs:", error);
        }
    };
};





function setNewToken(token) {
    if (token) {
        localStorage.setItem("token_id", token);
    }
}